"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ManualCard_1 = require("./ManualCard");
class ManualCardList extends React.Component {
    constructor() {
        super(...arguments);
        this.getDefaultImage = () => {
            const { cards } = this.props;
            const oneCardHasImage = cards.some(card => card.image);
            if (oneCardHasImage) {
                return "https://via.placeholder.com/215";
            }
            return null;
        };
    }
    render() {
        const { cards } = this.props;
        const defaultImage = this.getDefaultImage();
        return (React.createElement("div", { className: "ManualCardList" },
            React.createElement("div", { className: "row is-spaced" }, cards.map((card, index) => (React.createElement(ManualCard_1.ManualCard, { key: index, image: card.image || defaultImage, title: card.title, content: card.content }))))));
    }
}
exports.ManualCardList = ManualCardList;
exports.default = ManualCardList;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-manual-card-list/ManualCardList.tsx